import { z } from "zod";
import { emailSchema } from "../common/email.js";
import { ContactSubject } from "../landing/contact-subject.js";

export const communityContactFormSchema = z.object({
	name: z.string().trim().min(2, { message: "Name must be at least 2 characters long" }).max(120),
	email: emailSchema,
	subject: z.enum(ContactSubject, { message: "Please select a subject" }),
	message: z.string().trim().min(10, { message: "Message must be at least 10 characters long" }).max(4000),
});

export type CommunityContactFormPayload = z.infer<typeof communityContactFormSchema>;
